import "slick-carousel";
import 'jquery-datetimepicker';

import AOS from "aos";
AOS.init({
    once: true,
    delay: 0,
    easing: "ease-in-out",
    duration: 1000,
    anchorPlacement: "top-center",
    startEvent: 'DOMContentLoaded',
});

// global
import "./global/global.js";
import "./global/modal.js";
import "./global/header.js";
import "./global/slick-options.js";
import "./global/parallax.js";
import "./global/handwriting.js";

import "./template-parts/accordion.js";
import "./template-parts/single-post.js";
import "./template-parts/card-slider.js";
import "./template-parts/form.js";
import "./template-parts/tabs.js";
import "./template-parts/card-camper-hire.js";

// blocks
import "./blocks/accreditations-slider.js";
import "./blocks/latest-blogs-slider.js";
import "./blocks/blog-listing.js";
import "./blocks/staggered-content.js";
